import { Directive, Input, OnInit } from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { QuestionBase } from "../components/dynamic-form/question-base";
import { AnyObject } from "../types/app.type";

@Directive({
  selector: "[bindQueryParamsToForm]",
})
export class BindQueryParamsToFormDirective implements OnInit {
  @Input() bindEnabled = true;
  @Input() questionsToBind: QuestionBase<string | boolean>[] = [];
  constructor(private ngControl: ControlContainer, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.bindEnabled) {
      this.mapQueryParamsToForm();
      this.mapFormToQueryParams();
    }
  }

  private mapQueryParamsToForm(): void {
    if (location.search) {
      const queryParams = new URLSearchParams(location.search);
      const values = Object.fromEntries(queryParams.entries());
      this.deleteExcludedKeys(values);
      this.ngControl.control.patchValue(this.convertValues(values));
    }
  }

  private mapFormToQueryParams(): void {
    this.ngControl.control.valueChanges.subscribe((values) => {
      this.updateQueryParams(values);
    });
  }

  private convertValues(values: AnyObject): AnyObject {
    return Object.keys(values).reduce((data, key) => {
      const value = values[key];

      // convert to boolean
      let convertedValue: number | boolean =
        value?.toLowerCase() === "true" ? true : value?.toLowerCase() === "false" ? false : undefined;
      if (convertedValue !== undefined) {
        return { ...data, [key]: convertedValue };
      }

      // convert to number
      convertedValue = Number(value);
      if (!isNaN(convertedValue)) {
        return { ...data, [key]: convertedValue };
      }

      // keep as string
      return { ...data, [key]: value };
    }, {});
  }

  private updateQueryParams(queryParams: Params) {
    this.deleteExcludedKeys(queryParams);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: "merge",
    });
  }

  private deleteExcludedKeys(values: AnyObject): void {
    const keysToInclude = this.questionsToBind.filter((qs) => qs.bindQueryParamsToForm).map((qs) => qs.key);
    // eslint-disable-next-line guard-for-in
    for (const key in values) {
      if (!values[key]) {
        values[key] = null;
      }
      if (!keysToInclude.includes(key)) {
        delete values[key];
      }
    }
  }
}
